require('./brokerMiFIDAllowDisclaimerContinue.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKMessage } = require('commonsComponents/OKMessage');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const CLASS_NAME = 'broker-mifid-allow-disclaimer-continue';

class BrokerMiFIDAllowDisclaimerContinue extends React.Component {

    buildResult(resultText) {
        if (resultText) {
            return (
                <div>
                    <h4 className={`${CLASS_NAME}__result-title`}>
                        <FormattedText value="consultMiFID-evaluationResult" format="uppercase" />
                    </h4>
                    <p className={`${CLASS_NAME}__info-bold`}>
                        {resultText}
                    </p>
                </div>
            );
        }
    }

    render() {
        const { clientEmail, onContinueOperation, disclaimerText, resultText } = this.props;
        const result = this.buildResult(resultText);

        return (
            <ContentBox
                title={formatText('broker-convenienceMifidTestOperateFinishingTest')}
                titleSeparator={true}
            >
                <div className={`${CLASS_NAME}__info`}>
                    <p>
                        <h2 className={`${CLASS_NAME}__subtitle`}>
                            <FormattedText value="consultMiFID-subtitle"/>
                        </h2>
                        <FormattedText className={`${CLASS_NAME}__info`}
                            value="broker-convenienceMifidTestAnswersSentToEmail"
                            injectedStrings={[clientEmail]}
                        />
                    </p>
                    <p className={`${CLASS_NAME}__info-bold`}>
                        {result}
                    </p>
                </div>
                <div className={`${CLASS_NAME}__disclaimer-message`}>
                    <OKMessage type="informative">
                        {disclaimerText}
                    </OKMessage>
                </div>
                <div className="wizard-success-step__separator" />
                <div className={`${CLASS_NAME}__footer`}>
                    <div className="row">
                        <div className="col-xs-6">
                            <OKButton
                                modifier="link-ghost"
                                onClick={this.props.onCancel}
                            >
                                <FormattedText value="broker-convenienceMifidTestCancelOperation"/>
                            </OKButton>
                        </div>
                        <div className="col-xs-6 text-right">
                            <OKButton modifier="secondary" onClick={onContinueOperation}>
                                <FormattedText value="broker-convenienceMifidTestContinueOperation"/>
                            </OKButton>
                        </div>
                    </div>
                </div>
            </ContentBox>
        );
    }
}

BrokerMiFIDAllowDisclaimerContinue.propTypes = {
    clientEmail: PropTypes.string.isRequired,
    onContinueOperation: PropTypes.func.isRequired,
    disclaimerText: PropTypes.string.isRequired,
    resultText: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
};

module.exports = BrokerMiFIDAllowDisclaimerContinue;